import { batch } from 'react-redux';

import { getAllEmployeeFeedbacks } from 'services/OneOnOne';

import { apiMetaUpdateHasMoreAction, apiMetaUpdateOffsetAction } from './apiPaginationMeta';
import { apiStatusSetCompletedAction, apiStatusSetLoadingAction, apiStatusSetLoadingMoreAction } from './apiStatus';

export const FEEDBACKS_REDUCER_ADD = 'FEEDBACKS_REDUCER_ADD';
export const FEEDBACKS_REDUCER_UPDATE = 'FEEDBACKS_REDUCER_UPDATE';

export function fetchFeedbacksAction({ type = null, globalFilters = {}, receiverEmployeeId }) {
  return (dispatch, getState) => {
    const { apiPaginationMeta } = getState();
    const { limit } = apiPaginationMeta;
    const offset = 0;

    dispatch(apiStatusSetLoadingAction());
    return getAllEmployeeFeedbacks({
      offset,
      limit: limit + 1,
      empId: receiverEmployeeId,
    })
      .then((feedbacks) => {
        const sliceFeedbacks = feedbacks.slice(0, -1);
        batch(() => {
          dispatch(updateFeedbacksAction(feedbacks.length > limit ? sliceFeedbacks : feedbacks));
          dispatch(apiStatusSetCompletedAction());
          dispatch(apiMetaUpdateOffsetAction(feedbacks.length > limit ? offset + limit : offset));
          dispatch(apiMetaUpdateHasMoreAction(feedbacks.length > limit));
        });
      })
      .catch((err) =>
        batch(() => {
          dispatch(apiStatusSetCompletedAction());
          dispatch(apiMetaUpdateHasMoreAction(false));
        })
      );
  };
}

export function fetchMoreFeedbacksAction({ receiverEmployeeId }) {
  return (dispatch, getState) => {
    const state = getState();
    const { limit = 5, offset = 0 } = state.apiPaginationMeta;
    dispatch(apiStatusSetLoadingMoreAction());
    return getAllEmployeeFeedbacks({
      limit: limit + 1,
      offset,
      empId: receiverEmployeeId,
    })
      .then((feedbacks) => {
        const sliceFeedbacks = feedbacks.slice(0, -1);
        batch(() => {
          dispatch(addFeedbacksAction(feedbacks.length > limit ? sliceFeedbacks : feedbacks));
          dispatch(apiStatusSetCompletedAction());
          dispatch(apiMetaUpdateOffsetAction(feedbacks.length > limit ? offset + limit : offset));
          dispatch(apiMetaUpdateHasMoreAction(feedbacks.length > limit));
        });
      })
      .catch((err) =>
        batch(() => {
          dispatch(apiStatusSetCompletedAction());
          dispatch(apiMetaUpdateHasMoreAction(false));
        })
      );
  };
}

export function updateFeedbacksAction(feedbacks) {
  return { type: FEEDBACKS_REDUCER_UPDATE, feedbacks };
}

export function addFeedbacksAction(feedbacks) {
  return { type: FEEDBACKS_REDUCER_ADD, feedbacks };
}
